import { gql } from "@apollo/client";

const SHIPPOP_ESTIMATED_SHIPPING_PRICE = gql`
  query shippopEstimatedShippingPrice($projectId: ID!, $orderId: ID!, $carrierName: String) {
    shippopEstimatedShippingPrice(projectId: $projectId, orderId: $orderId, carrierName: $carrierName)
  }
`;

export default SHIPPOP_ESTIMATED_SHIPPING_PRICE;
